import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import Chip from '@mui/material/Chip';
import { Poll } from '../types';
import { useStringsContext } from '../../../../contexts/strings';

interface Props {
  selectedPoll: Poll;
  pollStatus: string | null;
}

const PollTitle = ({ selectedPoll, pollStatus }: Props) => {
  const { strings } = useStringsContext();

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Stack>
        <Typography variant="h5">{selectedPoll.name}</Typography>
        <Typography variant="body2">
          {`Skapad ${moment(selectedPoll.createdAt).format('YYYY-MM-DD HH:mm')}`}
        </Typography>
      </Stack>
      {pollStatus === 'ONGOING' && <Chip label={strings.polls.statusOngoing} color="success" />}
      {pollStatus === 'FINISHED' && <Chip label={strings.polls.statusFinished} />}
      {pollStatus === 'UPCOMING' && <Chip label={strings.polls.statusUpcoming} color="warning" />}
    </Stack>
  );
};

export default PollTitle;
